import { ShapePlacement, ShapeSize } from '../../model/types';

export const shapeSizing = {
  getRectSize: ({ width, height }: ShapeSize, { x, y }: ShapePlacement, snapStepPixels: number) => {
    return {
      width: Math.round(width / snapStepPixels) * snapStepPixels,
      height: Math.round(height / snapStepPixels) * snapStepPixels,
      x: Math.round((x - width / 2) / snapStepPixels) * snapStepPixels,
      y: Math.round((y - height / 2) / snapStepPixels) * snapStepPixels,
    };
  },
  getEllipseSize: ({ width, height }: ShapeSize, { x, y }: ShapePlacement, snapStepPixels: number) => {
    return {
      radiusX: Math.round(width / 2 / snapStepPixels) * snapStepPixels,
      radiusY: Math.round(height / 2 / snapStepPixels) * snapStepPixels,
      x: Math.round(x / snapStepPixels) * snapStepPixels,
      y: Math.round(y / snapStepPixels) * snapStepPixels,
    };
  },
};
